class Logger {
  static log = (method, message, obj, objName = 'Obj') => {
    if (window.__debug__) {
      const currentDate = new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      console.log(
        `%c [INFO]: ${currentDate} |  %c ${method} | ${message}`,
        'background: blue; color: white; display: block;',
        'background: green; color: white; display: block;'
      );

      if (obj) {
        console.group(objName);
        console.log(obj);
        console.groupEnd();
      }
    }
  };
}

export default Logger;
